<template>
  <div class="ml-2 mb-3">
    <v-dialog v-model="dialogDetailCourse" max-width="900px">
      <DetailCourse
          v-if="currentCourse && currentCourse.id"
          :courseId="currentCourse.id"
          ref="detailCourse"
          @close="dialogDetailCourse = false"
      >
      </DetailCourse>
    </v-dialog>

    <HeaderOrders
        :arrow="true"
        :title="comboId ? 'Editar combo': 'Editar combo'"
        :text="comboId ? 'Editar combo': 'Cadastrar combo'"
        :haveAction="true"
        actionTitle="Novo Pedido"
        @voltar="goToRoute('/cursos')"
    >
    </HeaderOrders>

    <v-card elevation="1">
      <v-container
          style="max-width: unset"
          class="pa-1 pt-1 ma-0"
      >
        <v-form ref="courseForm" v-model="courseForm" lazy-validation>
          <v-row cols="12" class="ma-0">
            <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
              <label>Nome</label>
              <v-text-field
                  outlined
                  placeholder="Nome do curso"
                  v-model="combo.name"
                  attach
                  dense
                  clearable
                  :rules="[rules.required]"
                  color="#000000"
              >
              </v-text-field>
            </v-col>

            <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
              <label>Descrição</label>
              <v-text-field
                  outlined
                  placeholder="Descrição do curso"
                  v-model="combo.description"
                  attach
                  dense
                  clearable
                  :rules="[rules.required]"
                  color="#000000"
              >
              </v-text-field>
            </v-col>
          </v-row>

          <v-row cols="12" class="ma-0">
            <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
              <label>Preço</label>
              <vuetify-money
                  :id="combo.price"
                  color="black"
                  v-bind:outlined="outlined"
                  placeholder="0.00"
                  required
                  :rules="[rules.required]"
                  hide-details
                  dense
                  v-model="combo.price"
                  v-bind:options="options"
                  style="border: 1px solid #979797; border-radius: 7.5px"
              ></vuetify-money>
            </v-col>
          </v-row>

          <v-row cols="12" class="ma-0 px-1">
            <v-card
                elevation="1"
                class=""
                width="100%"
            >
              <v-toolbar
                  color="#bc0000"
                  dark
                  elevation="0"
                  height="40"
              >
                <p class="title-toolbar">Cursos adicionados ao combo</p>

                <v-spacer></v-spacer>
              </v-toolbar>

              <v-row cols="12" class="ma-0 pa-1" v-if="selectedCourse && selectedCourse.length > 0">
                <v-col
                    class="ma-0 pa-1"
                    v-for="course in selectedCourse"
                    :key="course.id"
                    cols="12" xs="12" sm="12" md="6" lg="4" xl="4"
                >
                  <v-card
                      elevation="1"
                      class="px-3 py-2 ma-0 pa-0 "

                  >
                    <div class=" ">
                      <div>
                        <p class="mb-2">
                          <strong class="mr-1">Nome:</strong>
                          <span>{{ course.name }}</span>
                        </p>

                        <p class="mb-2">
                          <strong class="mr-1">Data de início:</strong>
                          <span>{{ formatDate(course.startDate) }}</span>
                        </p>
                        <p class="mb-2">
                          <strong class="mr-1">Data de término:</strong>
                          <span>{{ formatDate(course.endDate) }}</span>
                        </p>

                        <p class="mb-2">
                          <strong class="mr-1">Quantidade de vagas:</strong>
                          <span>{{ course.numberOfVacancies }}</span>
                        </p>

                        <div class="mb-3">
                          <label><strong>Preço</strong></label>
                          <vuetify-money
                              :id="course.price"
                              color="black"
                              v-bind:outlined="outlined"
                              placeholder="0.00"
                              required
                              :rules="[rules.required]"
                              hide-details
                              dense
                              v-model="course.price"
                              v-bind:options="options"
                              style="border: 1px solid #979797; border-radius: 7.5px"
                          ></vuetify-money>
                        </div>
                      </div>

                      <div>
                        <v-btn
                            outlined
                            tile
                            style="border-radius: 4px"
                            class="quinary-button"
                            color="quaternary"
                            width="120"
                            @click="removeCourse(course)"
                        >
                          <v-icon size="25" dark>mdi-trash-can-outline</v-icon>
                          <span>Remover</span>
                        </v-btn>

                        <v-btn
                            outlined
                            tile
                            style="border-radius: 4px"
                            class="quinary-button ml-3"
                            color="quaternary"
                            width="120"
                            @click="showDialogDetailCourse(course)"
                        >
                          <v-icon size="25" dark>mdi-eye-outline</v-icon>
                          <span>Detalhar</span>
                        </v-btn>
                      </div>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
              <v-row cols="12" class="ma-0" v-else>
                <h4 class="pa-3">Não há cursos adicionados ao combo</h4>
              </v-row>
            </v-card>
          </v-row>

          <v-row cols="12" class="ma-0 px-1">
            <v-card
                elevation="1"
                class=""
                width="100%"
            >
              <v-toolbar
                  color="#bc0000"
                  dark
                  elevation="0"
                  height="40"
              >
                <p class="title-toolbar">Selecione os cursos que serão adicionados ao combo</p>

                <v-spacer></v-spacer>
              </v-toolbar>

              <v-row cols="12" class="ma-0 pa-1" v-if="courses && courses.length > 0">
                <v-col
                    class="ma-0 pa-1"
                    v-for="course in courses"
                    :key="course.id"
                    cols="12" xs="12" sm="12" md="6" lg="4" xl="4"
                >
                  <v-card
                      elevation="1"
                      class="px-3 py-2 ma-0 pa-0"

                  >
                    <div class=" ">
                      <div>
                        <p class="mb-2">
                          <strong class="mr-1">Nome:</strong>
                          <span>{{ course.name }}</span>
                        </p>

                        <p class="mb-2">
                          <strong class="mr-1">Data de início:</strong>
                          <span>{{ formatDate(course.startDate) }}</span>
                        </p>
                        <p class="mb-2">
                          <strong class="mr-1">Data de término:</strong>
                          <span>{{ formatDate(course.endDate) }}</span>
                        </p>

                        <p class="mb-2">
                          <strong class="mr-1">Quantidade de vagas:</strong>
                          <span>{{ course.numberOfVacancies }}</span>
                        </p>
                        <p class="mb-2">
                          <strong class="mr-1">Preço:</strong>
                          <span>{{ formatCurrency(course.price) }}</span>
                        </p>
                      </div>

                      <div>
                        <v-btn
                            outlined
                            tile
                            style="border-radius: 4px"
                            class="quinary-button"
                            color="quaternary"
                            width="120"
                            @click="addCourse(course)"
                        >
                          <v-icon size="25" dark>mdi-plus</v-icon>
                          <span>Adicionar</span>
                        </v-btn>

                        <v-btn
                            outlined
                            tile
                            style="border-radius: 4px"
                            class="quinary-button ml-3"
                            color="quaternary"
                            width="120"
                            @click="showDialogDetailCourse(course)"
                        >
                          <v-icon size="25" dark>mdi-eye-outline</v-icon>
                          <span>Detalhar</span>
                        </v-btn>
                      </div>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
              <v-row cols="12" class="ma-0" v-else>
                <h4 class="pa-3">Não há cursos cadastrados ou ativos</h4>
              </v-row>
            </v-card>
          </v-row>

          <v-row class="d-flex justify-center pt-0 ma-0 pa-0">
            <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
              <v-btn
                  elevation="0"
                  class="secondary-button"
                  width="100%"
                  @click="goToRoute('/cursos')"
              >
                <span>Voltar</span>
              </v-btn>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
              <v-btn
                  elevation="0"
                  class="primary-button"
                  width="100%"
                  @click="submit()"
              >
                <span v-if="comboId">Editar combo</span>
                <span v-else>Cadastrar combo</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import ApiService from "../../../../services/ApiService";
import HeaderOrders from "@/views/pages/Orders/components/HeaderOrders.vue";
import Vue from "vue";
import Utils from "@/Utils/FormatDate";
import UtilsFormatCurrency from "@/Utils/FormatCurrency";
import DetailCourse from "@/views/pages/Courses/components/DetailCourse.vue";

export default {
  name: "Combo",
  components: {DetailCourse, HeaderOrders},
  computed: {},

  props: {},

  created() {
  },

  async mounted() {
    this.comboId = null
    const {comboId} = this.$route.query
    this.comboId = comboId
    if (this.comboId) {
      this.combo = {
        name: null,
        description: null,
        price: 0.00,
      }
      await this.getCombo()
    }
    await this.getCourses()
  },
  data() {
    return {
      selectedCourse: [],
      dialogDetailCourse: false,
      currentCourse: Object,
      outlined: true,
      options: {
        locale: "pt-BR",
        prefix: "R$",
        suffix: "",
        length: 11,
        precision: 2,
        max: 10
      },
      combo: {
        name: null,
        description: null,
        price: 0.00,
      },
      courses: [],
      courseForm: false,
      comboId: null,
      apiService: new ApiService(),
      rules: {
        required: (value) => !!value || "Campo requerido.",
      }
    };
  },

  methods: {
    formatNowFormat(date) {
      return Utils.nowFormat(date);
    },
    formatDate(date) {
      return Utils.momentDay(date);
    },
    formatCurrency(value) {
      return UtilsFormatCurrency.formatCurrency(value);
    },
    async addCourse(course) {
      try {
        const findIndex = this.selectedCourse.findIndex((x) => x.id === course.id)
        if (findIndex > -1) {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "",
            message: "Este curso já foi adicionado ao combo",
            trace: null,
          });
          return
        }
        const courseAux = await this.getCourse(course.id)
        this.selectedCourse.push(courseAux)
      } catch (e) {
        console.log(e)
      }
    },
    removeCourse(course){
      try {
        const findIndex = this.selectedCourse.findIndex((x) => x.id === course.id)
        if(findIndex > -1){
          this.selectedCourse.splice(findIndex, 1)
        }
      } catch (e) {
        console.log(e)
      }
    },

    async getCourse(courseId) {
      try {
        const {content} = await this.apiService.get(`course/${courseId}`,)
        return content
      } catch (e) {

      }
    },

    async getCombo() {
      try {
        const {content} = await this.apiService.get(`combo/${this.comboId}`,)
        this.combo = content
        this.selectedCourse = this.combo.combosTOCourses.map(x => {
          x.course.price = x.price
          return{
            ...x.course,
          }
        })
      } catch (e) {

      }
    },

    async getCourses() {
      try {
        const {content} = await this.apiService.get(`course/active`,)
        this.courses = content
      } catch (e) {

      }
    },

    showDialogDetailCourse(course) {
      this.currentCourse = course
      this.dialogDetailCourse = true
      setTimeout(() => {
        this.$refs.detailCourse.getCourse()
      }, 100)
    },

    async goToRoute(route) {
      await this.$router.push(route);
    },

    async submit() {
      try {
        const body = this.combo
        if (!this.$refs.courseForm.validate()) {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "",
            message: "Preencha os campos corretamente",
            trace: null,
          });
          return
        }
        if (!this.selectedCourse || this.selectedCourse.length <= 0) {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "",
            message: "Adicione mais cursos para incluir no combo!",
            trace: null,
          });
          return
        }
        if (!this.combo.price) {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "",
            message: "Informe o preço do curso!",
            trace: null,
          });
          return
        }
        let message = ''
        let statusCode = null
        body.courses = this.selectedCourse.map(x => {
          return {
            price: x.price,
            courseId: x.id
          }
        })
        if (this.comboId) {
          const response = await this.apiService.put(`combo/${this.comboId}`, body, false)
          message = response.message
          statusCode = response.statusCode
        } else {
          const response = await this.apiService.post("combo", body, false)
          message = response.message
          statusCode = response.statusCode
        }
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "success",
          title: message,
          message: message,
          trace: null,
        });
        if (statusCode == 200) {
          this.$refs.courseForm.reset()          // limpa todos os campos
          this.$refs.courseForm.resetValidation()
          this.selectedCourse = []
          await this.goToRoute('/cursos')
        }

      } catch (e) {

      }
    },
  },

  watch: {},
};
</script>

<style lang='scss' scoped>

.title-toolbar {
  font-size: 19px;
  margin-left: -15px;
  margin-bottom: -2px;
  font-weight: 500;
}

</style>
